import { SupplierFinance } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierFinance.Configuration
});

export default config;
